import React, { type FC, type PropsWithChildren, useState } from 'react'

import { type Plan } from '@/types/graphql'

type Cart = {
  plan?: Plan
  licencesCountValue?: number
}
type CartContextType = {
  cart: Cart | null
  actions: {
    setCart: (cart: Cart | null) => void
  }
}

const CartContext = React.createContext<CartContextType>({
  cart: null,
  actions: {
    setCart: () => {},
  },
})

const CartProvider: FC<PropsWithChildren> = ({ children }) => {
  const savedCart = localStorage.getItem('cart')
  const defaultCart = savedCart !== null ? JSON.parse(savedCart) : null
  const [cart, setCart] = useState(defaultCart)

  const handleCartUpdate = (updatedCart: Cart | null) => {
    localStorage.setItem('cart', JSON.stringify(updatedCart))
    setCart(updatedCart)
  }

  return (
    <CartContext.Provider
      value={ {
        cart,
        actions: { setCart: handleCartUpdate },
      } }

    >
      {children}
    </CartContext.Provider>
  )
}

export default CartProvider
export { CartContext }
